import { NaturalPersonFormValues } from 'features/new-actor/types/naturalPersonFormValues';
import { ValidationRules } from 'helpers/createFormConfig';
import { addressValidationRules } from './addressValidationRules';
import { personalInformationValidationRules } from './personalInformationValidationRules';

export const naturalPersonValidationRules: ValidationRules<Exclude<keyof NaturalPersonFormValues, 'id'>> =
{
  ...personalInformationValidationRules,
  ...addressValidationRules,
};
